import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter, Link } from 'react-router-dom'
import { logout } from 'Features/auth/actions'
import { getIsLoggedIn } from 'Features/auth/selectors'
import { Icon, Menu, Container, Image, Dropdown } from 'semantic-ui-react'
import { getUserFirstName, getIsUserActiveDirectory, getSystem, getUserId, getIsEnableIOTmodule ,LOGO_THEME} from 'Lib'
import TabSwitchLanguageNoBG from '../../ui/components/Item/tabSwitchLanguageNoBG'
import { translate } from 'react-switch-lang';

const header = {
    textDecoration: 'underline',
    fontSize: '1em'
}


const NoAuthHeader = () => (
    <div></div>
)

// const AuthHeader = ({ logout }) => (
class AuthHeader extends React.Component {
    constructor(props) {
        super(props)
        // const bsrs = getServiceToken()
        const firstName = getUserFirstName()
        const isUseAD = getIsUserActiveDirectory()
        const system = getSystem()
        this.state = ({
            logout: props.logout,
            firstName: typeof firstName !== 'undefined' ? firstName : '',
            isUseAD: isUseAD ? isUseAD : false,
            system: system,
            isEnableIotModule: getIsEnableIOTmodule()
        })
    }
    render() {
        let linkToInt = ''
        if (getSystem() === 'o365')
            linkToInt = '/integration'
        else if (getSystem() === 'exchange2013')
            linkToInt = '/exchangeIntegration'
        else if (getSystem() === 'google')
            linkToInt = '/googleIntegration'
        // const { isEnableIotModule } = this.state
        let isEnableIotModule = "true"

        const user_id = getUserId()
        let isProfile = false
        if (user_id === 'profile_user') {
            isProfile = true
        }
        const { t } = this.props
        return (

            <Menu secondary fixed="top" style={{ backgroundColor: "rgb(51, 51, 51)" }}>
                <Container style={{width:"100%", padding:"0px 15px", margin: 0}}>
                    <Menu.Item as={Link} to='/' className="menuImage">
                        <div style={{ height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Image
                                // size='small'
                                src={`/assets/images/logo_${LOGO_THEME}.png`}
                                style={{ display: 'inline-block', maxHeight: '100%' }}
                            />
                        </div>

                    </Menu.Item>
                    <Dropdown item text={t('header.masterData')} id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown item text={t('header.rooms')}>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/room/system'><Icon name='window restore' />{t('header.roomMail')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/room/core'><Icon name='database' />{t('header.roomRegis')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/room/subscribe'><Icon name='bell' />{t('header.roomSub')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/roomdisable'><Icon name='ban' />{t('header.roomDis')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/roomformat'><Icon name='sitemap' />{t('header.roomFormat')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/eventtype' ><Icon name='tasks' />{t('header.eventType')}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown item text={t('header.location')}>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/building'><Icon name='building' />{t('header.building')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/floor'><Icon name='hashtag' />{t('header.floor')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/zone'><Icon name='star' />{t('header.zone')}</Dropdown.Item>
                                    {/* <Dropdown item text='Seat'>
                                        <Dropdown.Menu>
                                            <Dropdown.Item as={Link} to='/registerseat'><Icon name='cubes' />All Seat</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown> */}
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown item text={t('header.Users')} id="menuHover">
                                <Dropdown.Menu>
                                    {
                                        this.state.isUseAD === 'true' &&
                                        <Dropdown.Item as={Link} to='/user/ad'><Icon name='adn' />{t('header.adUsers')}</Dropdown.Item>
                                    }
                                    <Dropdown.Item as={Link} to='/user/core'><Icon name='database' />{t('header.userRegis')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/user/group/list'><Icon name='users' />{t('header.Department')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/user/concurrent'><Icon name='users' />{t('header.userConcur')}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown item text={t('header.permission')} id="menuHover">
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/role/list'><Icon name='address book' />{t('header.Role')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/profile/list'><Icon name='user' />{t('header.Profile')}</Dropdown.Item>
                             </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown item text={t('header.Facilitites')}>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/amenity' ><Icon name='briefcase' />{t('header.Facilitites')}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                            <Dropdown item text={t('header.food')}>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/fbsCategory'><Icon name='coffee' />{t('header.Category')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/fbs'><Icon name='coffee' />{t('header.Foods')}</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
         
                            {/* <Dropdown item text={t('header.hotDesk')}>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/registerseat'>{t('header.seatRegis')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/hotdesk/availabletimeslot'>{t('header.avaiableTime')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/hotdesk/temporaryclosed' >{t('header.temporaryClosed')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/hotdesk/role'>{t('header.role')}</Dropdown.Item>
                                </Dropdown.Menu> */}
                            {/* </Dropdown> */}
                            <Dropdown item text={t('header.device')}>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/background'><Icon name='flag' />{t('header.Background')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/logo'><Icon name='flag' />{t('header.logo')}</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/display'><Icon name='at' />{t('header.iotDisplay')}</Dropdown.Item>
                                    {
                                        isEnableIotModule && isEnableIotModule === 'true' &&
                                        <Dropdown.Item as={Link} to='/iot'><Icon name='at' />{t('header.iotRegis')}</Dropdown.Item>
                                    }{
                                        isEnableIotModule && isEnableIotModule === 'true' &&
                                        <Dropdown.Item as={Link} to='/allcontrol'><Icon name='tag' />{t('header.iotRoomConfig')}</Dropdown.Item>
                                    }
                            </Dropdown.Menu>
                            </Dropdown>
                          

                            {/* <Dropdown.Item as={Link} to='/display'><Icon name='at' />{t('header.iotDisplay')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/iot'><Icon name='at' />{t('header.iotRegis')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/iotRoom'><Icon name='at' />{t('header.iotRoomConfig')}</Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* <Dropdown.Item as={Link} to='/registerseat' >Hotdesk</Dropdown.Item> */}
                    {/* </Dropdown.Menu> */}
                    {/* </Dropdown> */}
                    <Dropdown item text={t('header.Events')} id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to='/events'><Icon name='calendar' />{t('header.viewEvents')}</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    {/* <Dropdown item text={t('header.Orders')} id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to='/order'><Icon name='coffee' />{t('header.Foods')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/orderamenity'><Icon name='briefcase' />{t('header.Facilitites')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/events/order'><Icon name='plus' />{t('header.createOrder')}</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown> */}

                    {/* <Dropdown item text='Master' id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown item text='Users'>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/user/o365'><Icon name='windows' />O365 User</Dropdown.Item>
                                    {
                                        this.state.isUseAD === 'true' &&
                                        <Dropdown.Item as={Link} to='/user/ad'><Icon name='adn' />AD User</Dropdown.Item>
                                    }
                                    <Dropdown.Item as={Link} to='/user/core'><Icon name='database' />Regis User</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/user/group/list'><Icon name='users' />User Group</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                            <Dropdown item text='Foods & Beverage'>
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} to='/fbsCategory'><Icon name='food' />Category</Dropdown.Item>
                                    <Dropdown.Item as={Link} to='/fbs'><Icon name='food' />Food</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>

                        </Dropdown.Menu>
                    </Dropdown> */}
                    <Dropdown item text={t('header.Settings')} id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Item as={Link} to='/setting'><Icon name='setting' />{t('header.globalSetting')}</Dropdown.Item>
                            {
                                isProfile &&
                                <Dropdown.Item as={Link} to={linkToInt}><Icon name='cogs' />{t('header.Integration')}</Dropdown.Item>
                            }
                            {/* {
                                this.state.isProfile &&
                                <Dropdown.Item as={Link} to='/exchangeIntegration'><Icon name='cogs' />Exchange Integration</Dropdown.Item>
                            }
                            {
                                this.state.isProfile &&
                                <Dropdown.Item as={Link} to='/googleIntegration'><Icon name='cogs' />Google Integration</Dropdown.Item>
                            } */}
                            <Dropdown.Item as={Link} to='/term'><Icon name='setting' />{t('header.Terms')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/faq'><Icon name='setting' />{t('header.FAQ')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/contact'><Icon name='setting' />{t('header.Contact')}</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item text={t('header.Report')} id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Header style={header}>{t('header.Summary')}</Dropdown.Header>
                            {/* <Dropdown.Item as={Link} to='/report/statussummary'>Status Summary</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/statussummary'>Overview</Dropdown.Item> */}
                            <Dropdown.Item as={Link} to='/report/roomsummary'>{t('header.roomSummary')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/usersummary'>{t('header.userSummary')}</Dropdown.Item>
                            {/* <Dropdown.Item as={Link} to='/report/foodsummary'>{t('header.foodSummary')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/facilitysummary'>{t('header.facilitySummary')}</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/deleteeventsummary'>{t('header.deleteEventSummary')}</Dropdown.Item> */}
                            <Dropdown.Divider />
                            <Dropdown.Header style={header}>{t('header.reserveNotUse')}</Dropdown.Header>
                            <Dropdown.Item as={Link} to='/report/notuse/room'>{t('header.Room')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/notuse/user'>{t('header.User')}</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Header style={header}>{t('header.Detail')}</Dropdown.Header>
                            <Dropdown.Item as={Link} to='/report/roomreport'>{t('header.roomDetails')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/userreport'>{t('header.userDetails')}</Dropdown.Item>
                            {/* <Dropdown.Item as={Link} to='/report/foodsummarybyevent'>{t('header.foodDetails')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/facilitysummarybyevent'>{t('header.facilityDetails')}</Dropdown.Item> */}
                            {/* <Dropdown.Divider /> */}
                            {/* <Dropdown.Header style={header}>New Report</Dropdown.Header> */}
                            {/* <Dropdown.Item as={Link} to='/report/overview'>Overview</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/overview'>Room</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/byroom'>By Room</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/byuser'>By User</Dropdown.Item> */}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown item text={t('header.Monitor')} id="menuHover">
                        <Dropdown.Menu>
                            <Dropdown.Header style={header}>{t('header.Summary')}</Dropdown.Header>
                            {/* <Dropdown.Item as={Link} to='/report/statussummary'>Status Summary</Dropdown.Item> */}
                            <Dropdown.Item as={Link} to='/report/statussummary'>{t('header.Overview')}</Dropdown.Item>
                            {/* <Dropdown.Item as={Link} to='/report/roomsummary'> Room Summary</Dropdown.Item> */}
                            {/* <Dropdown.Item as={Link} to='/report/usersummary'> User Summary</Dropdown.Item> */}
                            <Dropdown.Divider />
                            {/* <Dropdown.Header style={header}>Detail</Dropdown.Header>
                            <Dropdown.Item as={Link} to='/report/userreport'>User Detail</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/roomreport'>Room Detail</Dropdown.Item>
                            <Dropdown.Divider /> */}
                            <Dropdown.Header style={header}>{t('header.Status')}</Dropdown.Header>
                            {/* <Dropdown.Item as={Link} to='/report/overview'>Overview</Dropdown.Item> */}
                            <Dropdown.Item as={Link} to='/report/overview'>{t('header.Room')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/overview/user/day'>{t('header.topUser')}</Dropdown.Item>
                            <Dropdown.Item as={Link} to='/report/overview/room/day'>{t('header.topRooms')}</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Menu.Menu position='right' >
                        {/* <Menu.Item> */}
                        <Dropdown item text={t('header.Hello') + `, ${this.state.firstName}`} id="lastMenuHover" >
                            <Dropdown.Menu>
                                {/* <Dropdown.Header>O365</Dropdown.Header>
                        <Dropdown.Item as={Link} to='/settings/integration'>Integration</Dropdown.Item>
                        <Dropdown.Item as={Link} to='/room/list'><Icon namee='microsoft' />O365 Rooms</Dropdown.Item>
                        <Dropdown.Divider /> */}
                                {/* <Dropdown.Header>Regis</Dropdown.Header>
                        <Dropdown.Item as={Link} to='/room'>Regis Room</Dropdown.Item>
                        <Dropdown.Item as={Link} to='/setting/user/list'>User List</Dropdown.Item>
                        <Dropdown.Item as={Link} to='/setting/user/add'>Regis User</Dropdown.Item> */}
                                <Dropdown.Item as={Link} to='/UserInfo'>{t('header.UserInformation')}</Dropdown.Item>
                                <Dropdown.Item onClick={this.state.logout}>  <Icon name='power' />{t('header.SignOut')}</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        <TabSwitchLanguageNoBG /> 

                    </Menu.Menu>
                </Container>
                {/* <TabSwitchLanguageNoBG /> */}
            </Menu>

        )
    }
}

const Header = ({ isLoggedIn, logout, t }) => (
    <div>
        {
            isLoggedIn ? <AuthHeader logout={logout} t={t} /> : <NoAuthHeader />
        }
    </div>
)

export default compose(
    withRouter,
    connect(
        state => ({ isLoggedIn: getIsLoggedIn(state) }),
        (dispatch, props) => ({
            logout() {

                dispatch(logout())
                props.history.push('/login')
            }
        })
    )
)(translate(Header))


// WEBPACK FOOTER //
// ./src/features/ui/components/Header.js